(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-mini-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pmgInit) return;
  window.__pmgInit = true;

  var dialog = null;
  var dialogTrack = null;
  var dialogCaption = null;
  var dialogDots = null;
  var dialogPrev = null;
  var dialogNext = null;

  function makeEl(tag, cls) {
    var el = document.createElement(tag);
    if (cls) el.className = cls;
    return el;
  }

  function makeCloseSvg() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var l1 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    l1.setAttribute('x1', '18'); l1.setAttribute('y1', '6');
    l1.setAttribute('x2', '6'); l1.setAttribute('y2', '18');
    var l2 = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    l2.setAttribute('x1', '6'); l2.setAttribute('y1', '6');
    l2.setAttribute('x2', '18'); l2.setAttribute('y2', '18');
    svg.appendChild(l1);
    svg.appendChild(l2);
    return svg;
  }

  function makeChevronSvg(direction) {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '20');
    svg.setAttribute('height', '20');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('stroke', 'currentColor');
    svg.setAttribute('stroke-width', '2.5');
    svg.setAttribute('stroke-linecap', 'round');
    svg.setAttribute('stroke-linejoin', 'round');
    var line = document.createElementNS('http://www.w3.org/2000/svg', 'polyline');
    line.setAttribute('points', direction === 'prev' ? '15 18 9 12 15 6' : '9 18 15 12 9 6');
    svg.appendChild(line);
    return svg;
  }

  function scrollByOne(track, delta) {
    var w = track.clientWidth;
    if (!w) return;
    var current = Math.round(track.scrollLeft / w);
    var target = Math.max(0, Math.min(track.children.length - 1, current + delta));
    track.scrollLeft = target * w;
    syncGalleryState(track, target);
  }

  function syncGalleryState(track, idx) {
    if (track === dialogTrack) {
      var spans = dialogDots ? dialogDots.querySelectorAll('span') : [];
      for (var i = 0; i < spans.length; i++) {
        spans[i].classList.toggle('is-active', i === idx);
      }
      updateArrowState(idx);
      return;
    }
    var gallery = track.closest && track.closest('[data-pmg]');
    if (!gallery) return;
    var dots = gallery.querySelectorAll('.pmg__dot');
    for (var j = 0; j < dots.length; j++) {
      dots[j].classList.toggle('is-active', j === idx);
    }
  }

  function updateArrowState(idx) {
    if (!dialogPrev || !dialogNext || !dialogTrack) return;
    if (typeof idx !== 'number') {
      var w = dialogTrack.clientWidth;
      if (!w) return;
      idx = Math.round(dialogTrack.scrollLeft / w);
    }
    var last = dialogTrack.children.length - 1;
    dialogPrev.disabled = idx <= 0;
    dialogNext.disabled = idx >= last;
  }

  // Fill [name] placeholders in one pass; a function replacement, so `$` in a value is never special.
  function fillLabel(template, values) {
    return template.replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : match;
    });
  }

  // Modal labels come from locale keys via data attributes on the gallery that opens it (see the markup above).
  function ensureDialog(gallery) {
    if (dialog) return;
    function label(name) { return (gallery && gallery.getAttribute('data-pmg-label-' + name)) || ''; }
    dialog = makeEl('dialog', 'pmg-modal');
    var inner = makeEl('div', 'pmg-modal__inner');
    var frame = makeEl('div', 'pmg-modal__frame');
    var closeBtn = makeEl('button', 'pmg-modal__close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('aria-label', label('close'));
    closeBtn.appendChild(makeCloseSvg());
    dialogPrev = makeEl('button', 'pmg-modal__arrow pmg-modal__arrow--prev');
    dialogPrev.type = 'button';
    dialogPrev.setAttribute('aria-label', label('prev'));
    dialogPrev.appendChild(makeChevronSvg('prev'));
    dialogNext = makeEl('button', 'pmg-modal__arrow pmg-modal__arrow--next');
    dialogNext.type = 'button';
    dialogNext.setAttribute('aria-label', label('next'));
    dialogNext.appendChild(makeChevronSvg('next'));
    dialogTrack = makeEl('div', 'pmg-modal__track');
    dialogDots = makeEl('div', 'pmg-modal__dots');
    dialogCaption = makeEl('div', 'pmg-modal__caption');
    frame.appendChild(closeBtn);
    frame.appendChild(dialogPrev);
    frame.appendChild(dialogNext);
    frame.appendChild(dialogTrack);
    frame.appendChild(dialogDots);
    frame.appendChild(dialogCaption);
    inner.appendChild(frame);
    dialog.appendChild(inner);
    document.body.appendChild(dialog);

    closeBtn.addEventListener('click', closeDialog);
    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) closeDialog();
    });
    dialogPrev.addEventListener('click', function (e) {
      e.stopPropagation();
      scrollByOne(dialogTrack, -1);
    });
    dialogNext.addEventListener('click', function (e) {
      e.stopPropagation();
      scrollByOne(dialogTrack, 1);
    });
    dialog.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollByOne(dialogTrack, -1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); scrollByOne(dialogTrack, 1); }
    });

    dialogTrack.addEventListener('scroll', function () {
      var w = dialogTrack.clientWidth;
      if (!w) return;
      var idx = Math.round(dialogTrack.scrollLeft / w);
      var spans = dialogDots.querySelectorAll('span');
      for (var i = 0; i < spans.length; i++) {
        spans[i].classList.toggle('is-active', i === idx);
      }
      updateArrowState();
    });
  }

  function clearChildren(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function openDialog(gallery, startIndex) {
    ensureDialog(gallery);
    var title = gallery.getAttribute('data-pmg-title') || '';
    var imageAlt = gallery.getAttribute('data-pmg-label-image') || '';
    var slides = gallery.querySelectorAll('[data-pmg-slide]');
    clearChildren(dialogTrack);
    clearChildren(dialogDots);
    for (var i = 0; i < slides.length; i++) {
      var src = slides[i].getAttribute('data-pmg-src');
      var img = document.createElement('img');
      img.src = src;
      img.alt = fillLabel(imageAlt, { title: title, index: i + 1 });
      img.loading = 'eager';
      dialogTrack.appendChild(img);
      if (slides.length > 1) {
        var dot = document.createElement('span');
        if (i === startIndex) dot.className = 'is-active';
        dialogDots.appendChild(dot);
      }
    }
    dialogCaption.textContent = title;
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    requestAnimationFrame(function () {
      var w = dialogTrack.clientWidth;
      if (w) dialogTrack.scrollLeft = w * startIndex;
      updateArrowState();
    });
  }

  function closeDialog() {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var arrow = e.target.closest('[data-pmg-arrow]');
    if (arrow) {
      var gallery = arrow.closest('[data-pmg]');
      if (!gallery) return;
      var track = gallery.querySelector('[data-pmg-track]');
      if (!track) return;
      e.preventDefault();
      e.stopPropagation();
      var delta = parseInt(arrow.getAttribute('data-pmg-arrow'), 10) || 1;
      scrollByOne(track, delta);
      return;
    }
    var btn = e.target.closest('[data-pmg-slide]');
    if (!btn) return;
    var gallery2 = btn.closest('[data-pmg]');
    if (!gallery2) return;
    e.preventDefault();
    e.stopPropagation();
    var idx = parseInt(btn.getAttribute('data-pmg-slide'), 10) || 0;
    openDialog(gallery2, idx);
  }, true);

  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track || !track.matches || !track.matches('[data-pmg-track]')) return;
    var w = track.clientWidth;
    if (!w) return;
    var idx = Math.round(track.scrollLeft / w);
    var gallery = track.closest('[data-pmg]');
    if (!gallery) return;
    var dots = gallery.querySelectorAll('.pmg__dot');
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === idx);
    }
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
